<template>
  <div style="width: 100%;margin-top: 5px;" class="cargo-advance-search approval-search">
    <div class="section">
      <!--高级查询-->
      <search-item
        :config-module="searchItemConfigs[type][documentConfigId].configModule"
        :grid-config-module="searchItemConfigs[type][documentConfigId].gridConfigModule"
        :custom-search-items="customSearchItems"
        :expand-adv="expandAdv"
        :custom-sim-query-placeholder="$t('Clearing.QuickRetrieval') + $t('CargoMsg.Cargo_ApprovalSerialNumber')"
        @perConfigChange="value=>{innerPerConfigName=value}"
        @refreshGrid="()=>{innerGridRefreshId+=1}"
        @advSearchItemCallBack="toQuery"
        @simSearchItemCallBack="toQuerySimple"
      >
        <div slot="operations">
          <el-form
            label-position="left"
            label-width="85px"
          >
            <el-row v-show="showBtn" style="margin-bottom: 5px;" :gutter="10">
              <el-col :span="24">
                <!--            <el-button type="primary" @click="toQuery">-->
                <!--              {{ $t('CargoMsg.Cargo_Query') }}-->
                <!--            </el-button>-->
                <!--            <el-button type="primary" @click="toReset">-->
                <!--              {{ $t('CargoMsg.Cargo_Reset') }}-->
                <!--            </el-button>-->
                <el-button v-if="showBatchBtn" type="primary" @click="toBatchApproval">
                  {{ $t('CargoMsg.Cargo_BatchApproval') }}
                </el-button>
                <el-button v-if="showBatchBtn" type="danger" @click="toBatchReject">
                  {{ $t('CargoMsg.Cargo_BatchReject') }}
                </el-button>
                <!--            <el-button v-if="showInitiateBtn" type="primary" @click="toInitiate">-->
                <!--              {{ $t('CargoMsg.Cargo_Initiate') }}-->
                <!--            </el-button>-->
                <el-button v-if="showPrintBtn" type="primary" @click="toPrint">
                  {{ $t('Payment.print') }}
                </el-button>
                <el-button v-if="viewSource === 'handleAll' && (isAdmin || $checkPermission(['button_ApprovalChecklistModule_cancel']))" type="primary" @click="toCancel">
                  {{ $t('CargoMsg.Cargo_Cancel') }}
                </el-button>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </search-item>
    </div>
  </div>
</template>

<script>
import * as WorkflowConstants from '@/class/cargo/model/parameters/WorkflowConstants'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import {
  VIEW_SOURCE_HANDLE_ALL,
  VIEW_SOURCE_INITIATE_ALL
} from '@/class/cargo/model/parameters/WorkflowConstants'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'

export default {
  name: 'ApprovalSearch',
  components: { CargoAdvanceSelect, searchItem },
  props: {
    status: { type: Number, default: () => 0 },
    showBtn: { type: Boolean, default: () => false },
    showBatchBtn: { type: Boolean, default: () => false },
    filter: {
      type: Object, default: () => {
      }
    },
    showInitiateBtn: { type: Boolean, default: () => false },
    showPrintBtn: { type: Boolean, default: () => false },
    // 来源【initiateAll：我发起的-全部 initiateProcessing：我发起的-处理中 initiateCompleted：我发起的-已完成 initiateRevoked：我发起的-已撤销 handleAll：我处理的-全部 handleTodo：我处理的-待处理 handleCompleted：我处理的-已完成】
    viewSource: { type: String, default: '' },
    // look：我发起的、approve：我处理的
    type: { type: String, default: '' },
    // 是否选择表单类型
    documentConfigId: { type: Number, default: 0 },
    perConfigName: { type: String, default: '' },
    gridRefreshId: { type: Number, default: 0 },
    expandAdv: { type: Boolean, default: false }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      workflowStates: Array.from(WorkflowConstants.WORKFLOW_STATE),
      workflowTemplates: Array.from(WorkflowConstants.WORKFLOW_TYPES),
      applicationDimensions: Array.from(WorkflowConstants.APPLICATION_DIMENSIONS),
      WORKFLOW_TYPE_LOOK: WorkflowConstants.WORKFLOW_TYPE_LOOK.code,
      WORKFLOW_TYPE_APPROVE: WorkflowConstants.WORKFLOW_TYPE_APPROVE.code,
      searchItemConfigs: {
        'look': [
          { searchItemCode: '我发起的', configModule: '330001', gridConfigModule: '33000101' },
          { searchItemCode: '我发起的-付款申请单', configModule: '330002', gridConfigModule: '33000202' },
          { searchItemCode: '我发起的-开票申请单', configModule: '330003', gridConfigModule: '33000303' },
          { searchItemCode: '我发起的-业务费用申请单', configModule: '330004', gridConfigModule: '33000404' },
          { searchItemCode: '我发起的-临时信控申请单', configModule: '330005', gridConfigModule: '33000505' },
          { searchItemCode: '我发起的-费用更改申请单', configModule: '330006', gridConfigModule: '33000606' },
          { searchItemCode: '我发起的-收票申请单', configModule: '330007', gridConfigModule: '33000707' },
          { searchItemCode: '', configModule: '', gridConfigModule: '' },
          { searchItemCode: '我发起的-合作伙伴申请单', configModule: '330008', gridConfigModule: '33000808' },
          { searchItemCode: '我发起的-合同申请单', configModule: '330009', gridConfigModule: '33000909' }
        ],
        'approve': [
          { searchItemCode: '我处理的', configModule: '440001', gridConfigModule: '44000101' },
          { searchItemCode: '我处理的-付款申请单', configModule: '440002', gridConfigModule: '44000202' },
          { searchItemCode: '我处理的-开票申请单', configModule: '440003', gridConfigModule: '44000303' },
          { searchItemCode: '我处理的-业务费用申请单', configModule: '440004', gridConfigModule: '44000404' },
          { searchItemCode: '我处理的-临时信控申请单', configModule: '440005', gridConfigModule: '44000505' },
          { searchItemCode: '我处理的-费用更改申请单', configModule: '440006', gridConfigModule: '44000606' },
          { searchItemCode: '我处理的-收票申请单', configModule: '440007', gridConfigModule: '44000707' },
          { searchItemCode: '', configModule: '', gridConfigModule: '' },
          { searchItemCode: '我处理的-合作伙伴申请单', configModule: '440008', gridConfigModule: '44000808' },
          { searchItemCode: '我处理的-合同申请单', configModule: '440009', gridConfigModule: '44000909' }
        ]
      },
      innerPerConfigName: '',
      innerGridRefreshId: 0,
      customSearchItems: []
    }
  },
  computed: {
    // 平台客服 or 系统管理员
    isAdmin() {
      return this.$store.getters.isAdmin
    }
  },
  watch: {
    perConfigName: {
      immediate: true,
      async handler(newVal) {
        this.innerPerConfigName = newVal
      }
    },
    innerPerConfigName(newVal) {
      this.$emit('update:perConfigName', newVal)
    },
    gridRefreshId: {
      immediate: true,
      async handler(newVal) {
        this.innerGridRefreshId = newVal
      }
    },
    innerGridRefreshId(newVal) {
      this.$emit('update:gridRefreshId', newVal)
    }
  },
  created() {
    // 只有【全部】的tab才显示【查询条件-状态】
    if (this.viewSource !== VIEW_SOURCE_INITIATE_ALL.code && this.viewSource !== VIEW_SOURCE_HANDLE_ALL.code) {
      // 删除状态查询条件
      const searchField = new AdvancedSearchField()
      searchField.itemType = 'select'
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST2'
      searchField.itemName = 'wdp.state'
      searchField.itemLabel = '"CargoMsg.Cargo_Status'
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.dropdownDataRef = 'WorkflowConstants.WORKFLOW_STATE'
      searchField.dataCacheKey = 'local_cache_WorkflowConstants$WORKFLOW_STATE'
      searchField.action = AdvancedSearchField.REMOVE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())
    }
  },
  methods: {
    toQuery(data) {
      // 高级查询条件组装
      this.filter.conditions = data
      this.filter.documentProcessNo = null
      // this.filter.simpleQuery = false
      this.$emit('toQuery')
    },
    toQuerySimple(data) {
      // 简单查询条件组装
      this.filter.conditions = null
      this.filter.documentProcessNo = data
      // this.filter.simpleQuery = true
      this.$emit('toQuery')
    },
    toBatchApproval() {
      this.$emit('toBatchApproval')
    },
    toBatchReject() {
      this.$emit('toBatchReject')
    },
    toInitiate() {
      this.$emit('toInitiate')
    },
    toPrint() {
      this.$emit('toPrint')
    },
    toCancel() {
      this.$emit('toCancel')
    },
    toReset() {
      this.filter.documentProcessNo = ''
      this.filter.startDate = ''
      this.filter.workflowName = ''
      this.filter.approveIdList = []
      if (!this.documentConfigId) {
        this.filter.documentConfigIdList = []
      }
      this.filter.state = ''
      this.filter.officeIdList = []
      this.filter.applicationDimensions = []
      this.filter.docNo = ''
      this.filter.lastModified = ''
    },
    temp(p) {
      console.log('p,value:' + JSON.stringify([...p.value]))
      this.filter.applicationDimensions = p.value
    }
  }
}
</script>
<style lang="scss">
  .approval-search{
    //.el-form{
    //  .el-form-item__content{
    //    width: 210px;
    //  }
    //  .el-date-editor--datetime{
    //    width: 210px !important;
    //  }
    //}
  }
</style>
